import ServiceBase from './ServiceBase';

const UPLOAD_TIMEOUT_MS = 60_000;

/**
 * Handles direct file uploads to pre-signed storage URLs (S3, R2).
 * No Authorization header — signed URL carries its own credentials.
 * No responseHelper — response has no data.code envelope.
 */
class StorageService extends ServiceBase {

    /**
     * Uploads a file to a pre-signed URL via HTTP PUT using XMLHttpRequest.
     * Provides byte-level progress via onProgress callback.
     * @param {string} signedUrl - Pre-signed upload URL from BE
     * @param {File} file - Browser File object
     * @param {Function|null} onProgress - Called with { loaded, total, percent } during upload
     * @returns {Promise<number>} HTTP status code on success
     * @throws {Error} on HTTP failure, network error or timeout
     */
    upload = (signedUrl, file, onProgress = null) => {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();

            // Report byte-level progress to caller
            xhr.upload.onprogress = (e) => {
                if (!e.lengthComputable || !onProgress) return;
                onProgress({
                    loaded: e.loaded,
                    total: e.total,
                    percent: Math.round((e.loaded / e.total) * 100),
                });
            };

            xhr.onload = () => {
                if (xhr.status >= 400) {
                    reject(new Error(`upload failed: ${xhr.status}`));
                    return;
                }
                resolve(xhr.status);
            };

            xhr.onerror = () => reject(new Error('upload network error'));
            xhr.ontimeout = () => reject(new Error('upload timed out'));

            xhr.timeout = UPLOAD_TIMEOUT_MS;

            xhr.open('PUT', signedUrl);

            // Content-Type must match what BE used when signing the URL
            xhr.setRequestHeader('Content-Type', file.type);

            xhr.send(file);
        });
    };
}

const storageService = new StorageService();
export default storageService;
